module.exports = __webpack_public_path__ + "img/t1-13.3b3528ef.png";